// extracted by mini-css-extract-plugin
module.exports = {"reviewRating":"styles_reviewRating___zZi4","stars":"styles_stars__LpEn1","stars__overlay":"styles_stars__overlay__ep236","value":"styles_value__P4dcg"};